export default "__VITE_ASSET__B6tMi2zQ__"